import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';

interface ComplianceLogo {
  imgName: string;
  altText: string;
  complianceLogosClass: string;
  url: string;
  geo?: string;
}

@Component({
  selector: 'app-compliance-logos',
  templateUrl: './compliance-logos.component.html',
  styleUrls: ['./compliance-logos.component.scss'],
})
export class ComplianceLogosComponent implements OnInit {
  @Input() public country: string;

  @ViewChild('complianceRef') private complianceRef!: ElementRef;

  public complianceLogos: ComplianceLogo[] = [];
  public ngOnInit(): void {
    this.complianceLogos = this.getComplianceLogos();
    console.log('kyles one----', this.country);
  }

  private getComplianceLogos(): ComplianceLogo[] {
    const baseLogos: ComplianceLogo[] = [
      {
        imgName: '/light/playerprotection.png',
        altText: 'player protection',
        complianceLogosClass: 'playerprotection',
        url: '/playerprotection',
        geo: 'row',
      },
      {
        imgName: '/light/betblocker.svg',
        altText: 'bet blocker',
        complianceLogosClass: 'betblocker',
        url: 'https://betblocker.org/',
        geo: 'row',
      },
      {
        imgName: '/light/gamblingtherapy.svg',
        altText: 'gambling therapy',
        complianceLogosClass: 'gamblingtherapy',
        url: 'https://www.gamblingtherapy.org/',
        geo: 'row',
      },
    ];

    if (['gb', 'uk'].includes(this.country)) {
      baseLogos.push(
        {
          imgName: '/light/gamble-aware-logo.svg',
          altText: 'Gamble Aware',
          complianceLogosClass: 'gambleaware',
          url: 'https://www.gambleaware.org/',
          geo: 'gb',
        },
        {
          imgName: '/light/gambling-commission.svg',
          altText: 'Gambling Commission',
          complianceLogosClass: 'gamblingcommission',
          url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/52894',
          geo: 'gb',
        },
        {
          imgName: '/light/gamstop.svg',
          altText: 'gamstop',
          complianceLogosClass: 'gamstop',
          url: 'https://www.gamstop.co.uk/',
          geo: 'gb',
        },
        {
          imgName: '/light/gamcare-full.png',
          altText: 'gamcare',
          url: 'https://www.gamcare.org.uk/get-support/talk-to-us-now/',
          complianceLogosClass: 'gamcare',
          geo: 'gb',
        }
      );
    } else {
      baseLogos.push({
        imgName: '/light/mga.svg',
        altText: 'mga',
        url: 'https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=633683dc-daea-49e5-9a7e-da843d38e7de&details=1',
        complianceLogosClass: 'mga',
        geo: 'row',
      });
    }

    return baseLogos;
  }
}
